import React, { useEffect, ReactNode, forwardRef } from 'react';

export interface IMutationChildProps {
    onChildDomChanged: () => void;
    children?: ReactNode;
}

export const MutationChild = forwardRef((props: IMutationChildProps, contentRef: React.Ref<HTMLDivElement>) => {
    useEffect(() => {
        let observer: MutationObserver | null = null;
        const ref = contentRef as React.RefObject<HTMLDivElement>;
        if (ref && ref.current) {
            const el = ref.current;
            observer = new MutationObserver((mutationsList) => {
                mutationsList.forEach((mutation) => {
                    if (mutation.type === 'childList') {
                        props.onChildDomChanged();
                    }
                });
            });
            observer.observe(el, { attributes: false, childList: true, subtree: true });
        }
        return () => {
            if (observer) {
                observer.disconnect();
            }
        };
    }, []);
    return (
        <div className="content" ref={contentRef}>
            {props.children}
        </div>
    );
});
